// Base URL de la API — única fuente de verdad.
// En dev, el proxy de Vite manda /api → http://localhost:3001; en prod es same-origin.
export const apiBase = import.meta.env.VITE_API_URL || '/api'
